import { render, staticRenderFns } from "./Trainer.vue?vue&type=template&id=63f9ae24"
import script from "@/views/Users/Trainer/Trainer.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Trainer/Trainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports